export type DocumentType = "protocol" | "protective";

/** Word may return caption-table text after the body. Check the whole document
 * for an ESI order title before falling back to incidental Protective Order references. */
export function detectDocTypeFromContent(content: string): DocumentType | null {
  const text = (content || "").replace(/\s+/g, " ").trim();
  if (!text) return null;
  const protocol = /\b(?:esi|e-?\s?discovery|electronically stored information)\s+protocol\b|\bprotocol\s+(?:for|governing|regarding)\s+(?:the\s+)?(?:discovery|production)\s+of\s+(?:esi|electronically stored information)\b|\border\s+(?:governing|regarding|concerning|for|re:?)\s+(?:the\s+)?(?:(?:discovery|production)\s+(?:of\s+)?)?(?:e-?discovery|electronically stored information|esi)\b|\b(?:stipulated\s+)?e-?discovery\s+(?:order|agreement|stipulation)\b|\b(?:esi|electronically stored information)\s+(?:agreement|stipulation)\b|\bstipulated\s+order\s+re:?\s+.{0,40}electronically\s+stored\s+information/i;
  const protective = /\b(?:stipulated\s+)?protective\s+order\b|\border\s+governing\s+confidentiality\b|\bconfidentiality\s+(?:and\s+)?protective\s+order\b/i;
  const head = text.slice(0, 1500);
  const protocolIndex = head.search(protocol);
  const protectiveIndex = head.search(protective);
  if (protocolIndex >= 0 && (protectiveIndex < 0 || protocolIndex <= protectiveIndex)) return "protocol";
  if (protectiveIndex >= 0) return "protective";
  if (protocol.test(text)) return "protocol";
  if (protective.test(text)) return "protective";
  return null;
}

/** A participant's explicit selection must survive subsequent analysis calls. */
export function resolveDocumentType(content: string, selected: DocumentType | null): DocumentType | null {
  return selected || detectDocTypeFromContent(content);
}
